<template>
  <div>
    <v-app-bar
      flat
      color="transparent"
    >
      <v-toolbar-title>
        Onboarding Options
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-row
        v-if="showSearch"
        align="center"
        style="max-width: 300px;"
      >
        <v-text-field
          flat
          hide-details
          single-line
          label="Search name, email or phone number"
          class="hidden-sm-and-down"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>
      <v-btn
        class="ml-5"
        icon
        @click="showSearch = !showSearch"
      >
        <img
          src="@/assets/icons/search.svg"
          alt=""
        >
      </v-btn> -->
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-row>
        <v-col md="4">
          <v-radio-group
            v-model="options_for"
            row
          >
            <v-radio
              label="SportsBooks"
              value="bookmaker"
            ></v-radio>
            <v-radio
              label="Leagues"
              value="league"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <leagues-list
          v-if="options_for === 'league'"
          :league_list='leagues'
          @refreshLeagueList="getRecords"
        />
        <bookmaker-list
          v-if="options_for === 'bookmaker'"
          :bookmaker_list='sportsBooksList'
          @refreshBookmakerList="getRecords"
        />
      </v-col>
    </v-row>
    <v-overlay
      absolute
      :value="loading"
    >
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LeaguesList from './leagues'
import BookmakerList from './sportsBooks'
import map from 'lodash/map'

export default {
  data () {
    return {
      options_for: 'league',
      loading_message: 'Fetching Data',
      loading: false
    }
  },

  computed: {
    ...mapState({
      leagues: state => state.tag.list,
      sportsBooksList: state => state.bookmaker.list
    })

  },

  components: {
    LeaguesList,
    BookmakerList
  },

  methods: {
    ...mapActions({
      getTags: 'tag/getTags',
      getBookList: 'bookmaker/getFreshBookList'
    }),
    async getLeagues () {
      try {
        this.loading = true
        this.loading_message = 'Fetching League list'
        this.errorMessage = null
        let params = { page: 1 }
        params.sort = 'onboarding_sort_index'
        await this.getTags(params)
      } catch (err) {
        this.errorMessage = 'Unable to retrieve data.'
      } finally {
        this.loading = false
      }
    },

    async triggerGetBookList () {
      try {
        let params = { page: 1 }
        this.loading = true
        this.loading_message = 'Fetching Bookmaker list'
        this.errorMessage = null
        params.sort = 'onboarding_sort_index'
        params.per_page = 100
        await this.getBookList(params)
      } catch (err) {
        this.errorMessage = 'Unable to retrieve data.'
      } finally {
        this.loading = false
      }
    },

    getRecords () {
      if (this.options_for === 'league') {
        this.getLeagues()
      } else {
        this.triggerGetBookList()
      }
    }
  },

  watch: {
    options_for: {
      immediate: true,
      handler: 'getRecords'

    }
  }

}
</script>
